<div class="modal-container">
  <div class="right-action-button">
    <button
      mat-icon-button
      matTooltip="Close Modal"
      color="warn"
      (click)="closeModal()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="w-full modal-header" *ngIf="header">
    <h1>{{ header }}</h1>
  </div>
  <div>
    <div #displayComponent></div>
  </div>
</div>
